import { compose } from '../../../utils/utils';

export function normalizePriceFormat(price: string | number): string {
    return compose<string | number, number>(parseFloat, String)(price).toFixed(2);
}
